import styled from '@emotion/styled'
import tw from 'twin.macro'

export const RedemptionErrorWrapper = styled('div')`
  ${tw`flex items-center p-3 border-t border-solid border-grey-200`}
`
